<template>
    <div class="sensitive-word-wrapper">
        <SensitiveWordsClassify :data="initData" />
        <ClassifyDetail v-if="groupsListData.length > 0 && !!initData" :data="initData" />
    </div>
</template>

<script>
import SensitiveWordsClassify from "./components/SensitiveWordsClassify";
import ClassifyDetail from "./components/ClassifyDetail";

export default {
    name: "SensitiveWordManage",
    components: {
        SensitiveWordsClassify,
        ClassifyDetail
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10
        };
    },
    computed: {
        groupsListData() {
            return this.getStorePorp("sensitiveGroupData");
        },
        initData() {
            return this.getStorePorp("sensitiveDetail");
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/querySensitiveGroupList", {
            page: this.curPage,
            size: this.curPageLen
        });
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.sensitiveWords[propName];
        }
    }
};
</script>

<style lang="scss" scoped>
.sensitive-word-wrapper {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    display: flex;
}
</style>
